import { ROUTE } from '@/constants';
import { loadView } from '../index';

const HomeView = loadView('home/HomeView');

const homeRoute = {
  path: ROUTE.PATH.HOME,
  component: () => import('@/layouts/default/DefaultLayout.vue'),
  meta: {
    auth: ROUTE.AUTH.USER_ROLE.AUTHORIZED,
  },
  children: [
    {
      path: '',
      name: ROUTE.NAME.HOME,
      component: HomeView,
      meta: {
        auth: ROUTE.AUTH.USER_ROLE.AUTHORIZED,
      },
    },
  ],
};

export default homeRoute;
